import { OrderTabsNames } from "../../../../orders/models/OrderTabs.enum";
import { NavigationPath } from "./../../../../../config/routing/NavigationPath";

export const generateItems = (
  state: any,
  pathname: string,
  actions: any,
  activeTab: string,
  editing: boolean
) => {
  const { addComment } = state;
  let items: Array<any> = [];

  if(editing){
    return []
  }else if (activeTab === OrderTabsNames.COMMENTS && !addComment) {
    items = [
      {
        key: "add",
        text: "Dodaj komentarz",
        iconProps: { iconName: "add" },
        name: "add",
        onClick: actions.addComment,
      },
    ];
  } else if (activeTab === OrderTabsNames.DETAILS) {
    if (pathname === NavigationPath.NEW_ORDERS) {
      items = [
        {
          key: "edit",
          text: "Edytuj",
          iconProps: { iconName: "edit" },
          onClick: actions.setEditing,
        },
        {
          key: "activate",
          text: "Akceptuj zamówienie",
          iconProps: { iconName: "followUser" },
          name: "activate",
          onClick: actions.setOrderAccepted,
        },
        {
          key: "delete",
          text: "Anuluj zamówienie",
          iconProps: { iconName: "delete" },
          name: "delete",
          onClick: actions.setOrderCanceled,
        },
      ];
    } else if (pathname === NavigationPath.ACCEPTED_ORDERS) {
      items = [
        {
          key: "edit",
          text: "Edytuj",
          iconProps: { iconName: "edit" },
          onClick: actions.setEditing,
        },
        {
          key: "delete",
          text: "Anuluj zamówienie",
          iconProps: { iconName: "delete" },
          name: "delete",
          onClick: actions.setOrderCanceled,
        },
      ];
    } else if (pathname === NavigationPath.IN_PROGRESS_ORDERS) {
      items = [
        {
          key: "edit",
          text: "Zakończ",
          iconProps: { iconName: "edit" },
          onClick: actions.setEditing,
        },
        {
          key: "delete",
          text: "Anuluj zamówienie",
          iconProps: { iconName: "delete" },
          name: "delete",
          onClick: actions.setOrderCanceled,
        },
        {
          key: "restore",
          text: "Przywróć do przyjętych",
          iconProps: { iconName: "Back" },
          name: "restore",
          onClick: actions.setOrderAccepted,
        },
      ];
    }
  }

  return items;
};
